import { useAuthenticated } from "@gettactic/hooks";
import { useUrlQuerySync } from "@webV2/hooks/useUrlQuerySync";
import { useMap } from "@webV2/map/MapProvider";
import { useRouter } from "next/router";

export const useMapPageUrlSync = (enabled = true) => {
  const router = useRouter();

  const {
    userContext: { currentOffice }
  } = useAuthenticated();

  const {
    floors,
    floor,
    changeStartDate,
    changeEndTime,
    startDate,
    endDate,
    timeMode,
    setTimeMode,
    setLocateResourceId,
    setFloor,
    filterQuery,
    setFilterQuery,
    defaultTab,
    setSection
  } = useMap();

  const onFloorChange = (floorId?: string) => {
    const foundFloor = floors?.find((floor) => floor.id === floorId);
    if (foundFloor) setFloor(foundFloor);
  };

  useUrlQuerySync(
    {
      date: startDate,
      officeId: currentOffice.id,
      floorId: floor?.id,
      startTime: startDate,
      endTime: endDate,
      timeMode,
      searchText: filterQuery || undefined, // Don't pass empty string to avoid it being converted to 0
      section: defaultTab
    },
    (paramsFromUrl) => {
      // Support old URL format with hash
      const [, hash] = (router.asPath as string).split("#");
      const parsedHash = new URLSearchParams(hash);
      const resourceId = parsedHash.get("resource") || null;
      const floorId = parsedHash.get("floorId") || null;
      const date =
        parsedHash.get("startTime") || parsedHash.get("dateTime") || null;
      const endDate = parsedHash.get("endTime") || null;

      const urlFloorId = floorId || paramsFromUrl.floorId;
      const urlResourceId =
        resourceId || (paramsFromUrl.resource as string | undefined);

      if (urlFloorId && urlFloorId !== floor?.id) {
        onFloorChange(String(urlFloorId));
      }

      if (urlResourceId) {
        // Use locateResourceId for URL-based navigation
        // This triggers the zoom and highlight flow which handles resource selection
        setLocateResourceId(urlResourceId);
      }

      if (
        paramsFromUrl.searchText &&
        paramsFromUrl.searchText !== filterQuery
      ) {
        setFilterQuery(String(paramsFromUrl.searchText));
      }

      if (paramsFromUrl.section && paramsFromUrl.section !== defaultTab) {
        setSection(paramsFromUrl.section as any);
      }
    },
    enabled && router.isReady && (floors?.length || 0) > 0,
    false,
    true
  );
};
